// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-bde38138]{\n  list-style-type:disc;\n  margin-left:1rem;\n  padding:0\n}\nul li[data-v-bde38138]{\n  text-align:left\n}\nul li>*[data-v-bde38138]{\n  vertical-align:initial\n}\nul li button[data-v-bde38138]{\n  vertical-align:top\n}\n.link[data-v-bde38138]{\n  text-decoration:underline;\n  color:var(--theme-light, #006cb8)\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
